import { useState, useEffect, useCallback } from 'react';
import request from '../utils/request';
import type { TagItem } from './types';
import type { UseSelectDataOptions, UseSelectDataReturn } from './types';

function useSelectData<T = unknown>(
  options: UseSelectDataOptions<T>
): UseSelectDataReturn<T> {
  const { url, params = {}, transform } = options;

  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await request.get(url, { params });
      const result = transform ? transform(res) : (res?.data ?? res ?? []);
      setData(Array.isArray(result) ? result : []);
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : '获取数据失败';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, [url, JSON.stringify(params)]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}

/**
 * 获取标签下拉数据
 * 接口: GET /api/select/tags
 */
export function useSelectTag(): UseSelectDataReturn<TagItem> {
  return useSelectData<TagItem>({ url: '/select/tags' });
}

export default useSelectData;